import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

// API for creating work order for field issue
export const postWorkOrderFieldIssue = (payload) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.post(`/workorder/addFeildIssurWorkOrderGeneration?fkUserId=${fkUserId}&role=${role}`, payload, {
    // return Axios.post(`addFeildIssurWorkOrderGeneration`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// API for getting list of all work order of field issue
export const getWorkOrderFieldIssueList = ( pageNo, jobType, fkUserId, role, headers ) => {
  return Axios.get(
    `/workorder/getWorkOrderJobFeildIssueList/${pageNo}?jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

export const getAllDispenserFieldIssueList = ( jobType, fkUserId, role, headers ) => {
  //let jobType = ["calibration"];
  return Axios.get(
    `/workorder/getWorkOrderJobFeildIssueListWithoutPagination?jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

// API for getting sr no of all work order of Field Visit
export const getWorkOrderFieldSrNo = (jobType, oprationType, customerName, headers) => {
  console.log("oprationType :-", oprationType);
  console.log("customerName :-", customerName);
  // return Axios.get(`getWorkOrderSerialNumber?jobType=${jobType}`, {
  return Axios.get(`/workorder/getWorkOrderSerialNumber?jobType=${jobType}&oprationType=${oprationType}&customerName=${customerName}`, {
    headers,
  });
};

export const getFieldVisitPdfDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let fileType = ["Pdf"];
  let jobType = ["field visit"];
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/workorder/getWorkOrderGenerationReportInPdf?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}&role=${role}&fkUserId=${fkUserId}&jobType=${jobType}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `workorderfeildvisitreport.pdf`);
  });
};

export const getFieldIssueWorkOrderExcelDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let fileType = ["Excel"];
  let jobType = ["field visit"];
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/workorder/getWorkOrderGenerationReportInPdf?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}&role=${role}&fkUserId=${fkUserId}&jobType=${jobType}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `workorderfieldvisitbetweentwodate.xlsx`);
  });
};

// API for getting list of all field visit by from and to date
export const getFieldEntryByDate = (pageNo, fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let jobType = ["field visit"];
  return Axios.get(
    `/workorder/getWorkOrderJobFeildIssueListBetweenTwoDate/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getFieldWorkOrderDetailsLExcel = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let jobType = ["field visit"];
  let fileType = ["Excel"];
  return Axios.get(
    `/workorder/getFieldWorkOrderDetailsListExcel?fileType=${fileType}&jobType=${jobType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
    ).then((response) => {
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileSaver.saveAs(blob, `FieldWorkOrderFieldVisitList.xlsx`);
    });
};

export const getFieldWorkOrderDetailsAllPdf = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let jobType = ["field visit"];
  let fileType = ["Pdf"];
  return Axios.get(
    `/workorder/getFieldWorkOrderDetailsListExcel?fileType=${fileType}&jobType=${jobType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
    ).then((response) => {
      var blob = new Blob([response.data], {
        type: "application/pdf",
      });
      fileSaver.saveAs(blob, `FieldWorkOrderFieldVisitList.pdf`);
    });
};

export const getDispenserDropDownListForFieldJob = (headers) => {
  return Axios.get(`/fieldjob/getDispenserDropDownListForFieldJob`, {
    headers
  });
};



export const getfieldissueDispenserSerialNumber = (pageNo, dispenserSrNo) => {

  const jobType = ["field visit"];
  const token = sessionStorage.getItem("token");

  // console.log('Role:', role, 'pkFieldIssueHistoryId:', pkFieldIssueHistoryId, 'Dispenser Serial Number:', dispenserSrNo);

  const url = `/workorder/getJobAssignmentsByDispenserAndJobType/${pageNo}?dispenserSrNo=${dispenserSrNo}&jobType=${jobType}`;

  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, 
 
    }
  };

  return Axios.get(url, config)
    .then(response => {
      console.log('Response Data:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('There was an error fetching the dispenser serial number:', error);
      if (error.response) {

        console.error('Response data:', error.response.data);
        console.error('Status:', error.response.status);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {

        console.error('The request was made but no response was received', error.request);
      } else {

        console.error('Error', error.message);
      }
      console.error('Config:', error.config);
    });
};



